import React, { useState } from "react";
import styled from "styled-components";
import { Link } from "gatsby";
import { Cart } from "./cart";

import { useCart } from "../context/cart-context";
import { useSettings } from "../hooks/useSettings";

const Header = styled.header`
  background: var(--background);
  border-bottom: 1px solid var(--border-color);
  position: sticky;
  top: 0;
  z-index: 1000;
  backdrop-filter: blur(10px);
  box-shadow: var(--shadow);
`;

const HeaderContainer = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 1rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 70px;
  
  @media (min-width: 768px) {
    padding: 0 2rem;
  }
`;

const SiteTitle = styled(Link)`
  font-size: 1.5rem;
  font-weight: 700;
  color: var(--primary-color);
  text-decoration: none;
  
  &:hover {
    color: var(--secondary-color);
  }
  
  @media (min-width: 768px) {
    font-size: 1.75rem;
  }
`;

const Nav = styled.nav`
  display: none;
  
  @media (min-width: 768px) {
    display: block;
  }
`;

const NavList = styled.ul`
  display: flex;
  gap: 2rem;
  list-style: none;
  margin: 0;
  padding: 0;
  align-items: center;
`;

const NavLink = styled(Link)`
  color: var(--text-color);
  font-weight: 500;
  padding: 0.5rem 1rem;
  border-radius: var(--border-radius);
  transition: var(--transition);
  
  &:hover {
    background-color: var(--background-light);
    color: var(--secondary-color);
  }
`;

const MobileMenuButton = styled.button`
  display: block;
  background: none;
  border: none;
  font-size: 1.5rem;
  color: var(--text-color);
  cursor: pointer;
  padding: 0.5rem;
  
  @media (min-width: 768px) {
    display: none;
  }
`;

const MobileNav = styled.nav`
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  background: var(--background);
  border-bottom: 1px solid var(--border-color);
  box-shadow: var(--shadow);
  transition: var(--transition);
  @media (min-width: 768px) {
    display: none;
  }
`;

const MobileNavList = styled.ul`
  list-style: none;
  margin: 0;
  padding: 1rem;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
`;

const MobileNavLink = styled(Link)`
  color: var(--text-color);
  font-weight: 500;
  padding: 1rem;
  border-radius: var(--border-radius);
  transition: var(--transition);
  display: block;
  
  &:hover {
    background-color: var(--background-light);
    color: var(--secondary-color);
  }
`;

const CartContainer = styled.div`
  position: relative;
  display: inline-block;
`;

const CartBadge = styled.span`
  position: absolute;
  top: -8px;
  right: -8px;
  background-color: var(--accent-color);
  color: white;
  border-radius: 50%;
  padding: 2px 6px;
  font-size: 0.75rem;
  min-width: 16px;
  text-align: center;
  font-weight: 600;
`;

const CartButton = styled.button`
  background: none;
  border: none;
  font-size: 1.25rem;
  color: var(--text-color);
  cursor: pointer;
  padding: 0.5rem;
  border-radius: var(--border-radius);
  transition: var(--transition);
  
  &:hover {
    background-color: var(--background-light);
  }
`

const PageHeader = () => {
  const { title, enableCart } = useSettings()
  // const cartContext  = useCart()
  // const [isCartOpen, setIsCartOpen] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  // const toggleCart = () => {
  //   setIsCartOpen(!isCartOpen);
  // };

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  // Get the total items in the cart
  // const totalItems = cartContext.state.items.reduce((total, item) => {
  //   return total + item.quantity;
  // }, 0)

  return (
    <Header>
      <HeaderContainer>
        <SiteTitle to="/">{title}</SiteTitle>
        
        <Nav>
          <NavList>
            <li>
              <NavLink to="/">Home</NavLink>
            </li>
            <li>
              <NavLink to="/books">Books</NavLink>
            </li>
            <li>
              <NavLink to="/blog">Blog</NavLink>
            </li>
            {/* {enableCart && (
              <li>
                <CartButton onClick={toggleCart}>
                  <CartContainer>
                    🛒
                    {totalItems > 0 && (
                      <CartBadge>{totalItems}</CartBadge>
                    )}
                  </CartContainer>
                </CartButton>
              </li>
            )} */}
          </NavList>
        </Nav>
        
        <MobileMenuButton onClick={toggleMobileMenu}>
          {isMobileMenuOpen ? '✕' : '☰'}
        </MobileMenuButton>
        
        {isMobileMenuOpen && (
          <MobileNav>
            <MobileNavList>
              <li>
                <MobileNavLink to="/" onClick={() => setIsMobileMenuOpen(false)}>Home</MobileNavLink>
              </li>
              <li>
                <MobileNavLink to="/books" onClick={() => setIsMobileMenuOpen(false)}>Books</MobileNavLink>
              </li>
              <li>
                <MobileNavLink to="/blog" onClick={() => setIsMobileMenuOpen(false)}>Blog</MobileNavLink>
              </li>
              {/* {enableCart && (
                <li>
                  <CartButton onClick={() => {
                    toggleCart();
                    setIsMobileMenuOpen(false);
                  }}>
                    <CartContainer>
                      🛒 Cart
                      {totalItems > 0 && (
                        <CartBadge>{totalItems}</CartBadge>
                      )}
                    </CartContainer>
                  </CartButton>
                </li>
              )} */}
            </MobileNavList>
          </MobileNav>
        )}
      </HeaderContainer>
      
      {/* <Cart 
        isopen={isCartOpen} 
        onClose={() => setIsCartOpen(false)} 
      /> */}
    </Header>
  );
};

export default PageHeader;
